import { GET_BANNERS, GET_BANNER, GET_HOME_BANNERS, SYSTEM_TOAST_SUCCESS_MESSAGE } from './types';

import { serverEndPoint } from './Utils';
import axios from 'axios';

export const getBanners = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/banner/getBanners`);
      if (status) {
        let banners = data.map((b)=>{
          let dataStart = b.startDate.substring(0,10).split('-').reverse().join('-')
          b.startDate = dataStart

          let dataEnd = b.endDate.substring(0,10).split('-').reverse().join('-')
          b.endDate = dataEnd

          return b
        })
        dispatch({
          type: GET_BANNERS,
          payload: banners,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getBannerById = (_id) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/banner/getBannerById/${_id}`);
      if (status) {
        let dataStart = data[0].startDate.substring(0,10)
        data[0].startDate = dataStart

        let dataEnd =data[0].endDate.substring(0,10)
        data[0].endDate = dataEnd

        dispatch({
          type: GET_BANNER,
          payload: data[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteBannerById = (_id) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.delete(`${serverEndPoint}/banner/deleteBannerById/${_id}`);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Banner deletado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const createBanner = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/banner/createBanner`, params);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Banner Adicionado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateBanner = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.put(`${serverEndPoint}/banner/updateBanner`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Banner Alterado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getHomeBanners = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/banner/getHomeBanners/true`);
      if (status === 200) {
        dispatch({
          type: GET_HOME_BANNERS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};
